import { DispatchLockingSystemReducer } from ".."

const setIsLoading = (dispatch: DispatchLockingSystemReducer, isLoading: boolean) => {
	dispatch({
		type: "SET_IS_LOADING",
		payload: isLoading,
	})
}

export default setIsLoading
